import { useRef, useCallback, useEffect } from "react";
import "./otpInput.css";

const OtpInput = ({ value = "", onChange, length = 4, disabled = false }) => {
  const inputsRef = useRef([]);

  const values = value.split("").concat(new Array(length - value.length).fill(""));

  useEffect(() => {
    inputsRef.current = inputsRef.current.slice(0, length);
  }, [length]);

  const focusInput = useCallback((idx) => {
    const el = inputsRef.current[idx];
    if (el) {
      el.focus();
      el.select();
    }
  }, []);

  const handleChange = (idx, e) => {
    const digit = e.target.value.replace(/\D/g, "").slice(-1);
    const newVal = value.split("");
    newVal[idx] = digit;
    const combined = newVal.join("").slice(0, length);
    onChange(combined);
    if (digit && idx < length - 1) {
      focusInput(idx + 1);
    }
  };

  const handleKeyDown = (idx, e) => {
    if (e.key === "Backspace") {
      if (!value[idx] && idx > 0) {
        const newVal = value.split("");
        newVal[idx - 1] = "";
        onChange(newVal.join(""));
        focusInput(idx - 1);
        return;
      }
      const newVal = value.split("");
      newVal[idx] = "";
      onChange(newVal.join(""));
    } else if (e.key === "ArrowLeft" && idx > 0) {
      focusInput(idx - 1);
    } else if (e.key === "ArrowRight" && idx < length - 1) {
      focusInput(idx + 1);
    } else if (e.key === "Delete") {
      const newVal = value.split("");
      newVal[idx] = "";
      onChange(newVal.join(""));
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, length);
    onChange(pasted);
    if (pasted.length === length) {
      focusInput(length - 1);
    } else {
      focusInput(pasted.length);
    }
  };

  return (
    <div className="otp-input">
      {Array.from({ length }, (_, i) => (
        <input
          key={i}
          ref={(el) => (inputsRef.current[i] = el)}
          type="text"
          inputMode="numeric"
          autoComplete={i === 0 ? "one-time-code" : "off"}
          maxLength={1}
          disabled={disabled}
          className={`otp-box${values[i] ? " is-filled" : ""}`}
          value={values[i] || ""}
          onChange={(e) => handleChange(i, e)}
          onKeyDown={(e) => handleKeyDown(i, e)}
          onPaste={i === 0 ? handlePaste : undefined}
          onFocus={(e) => e.target.select()}
          aria-label={`Digit ${i + 1}`}
        />
      ))}
    </div>
  );
};

export default OtpInput;
